import { WhiteLogoImg } from '../../../assets/images'

export default function Logo() {
  return <img src={WhiteLogoImg} alt="Logo" />
}
